import {shallowEqual} from 'react-redux';
import {assert} from 'assert-ts';
import {selectSettingsPreferredLocale} from 'services/settings';
import {useAppSelector} from 'store/hooks';
import type {ThesaurusId, ThesaurusMap} from '../types';
import {selectThesaurusData} from '../thesaurusSelectors';
import {getDummyThesaurus} from './getDummyThesaurus';

export const useThesaurusMap = (ids: ThesaurusId[]): ThesaurusMap => {
  const language = useAppSelector(selectSettingsPreferredLocale);

  return useAppSelector(state => {
    return ids.reduce<ThesaurusMap>((acc, id) => {
      const thesaurus = selectThesaurusData(id, language)(state);
      assert.soft(thesaurus, `useThesaurusList: Thesaurus ${id} not loaded`, {
        id,
      });

      acc[id] = thesaurus ?? getDummyThesaurus(id);
      return acc;
    }, {});
  }, shallowEqual);
};
